/* eslint-disable */
import Component from 'gia/Component'
import slick from 'slick-carousel'

export default class WhyTasmania extends Component {
  constructor(element) {
    super(element)
  }

  tassie() {
    const imageSlider = $(this.element).find('.images-slides-wapper')
    const contentSlider = $(this.element).find('.c-why-tasmania__info')
    const buttons = $(this.element).find('.links a')

    $(document).ready(function() {
      imageSlider.slick({
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipe: false,
        swipeToSlide: false,
        asNavFor: contentSlider,
        fade: true,
        infinite: false,
      })

      contentSlider.slick({
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipe: false,
        swipeToSlide: false,
        asNavFor: imageSlider,
        fade: true,
        infinite: false,
        //adaptiveHeight: true,
      })

      $(window).resize()
    })

    buttons.click(function(e) {
      e.preventDefault()
      const slideid = $(this).attr('id')
      const svgPoint = $(`svg g[id="${slideid}"]`)
      const slide = $(`.info__wrapper[data-slide-location="${slideid}"]`)
        .parent()
        .parent()
        .attr('data-slick-index')

      buttons.removeClass('active')
      $(this).addClass('active')
      $('svg g').removeClass('active')
      svgPoint.addClass('active')
      contentSlider.slick('slickGoTo', slide)
    })

    $(document).ready(function() {
      const slideid = $('.links a.active').attr('id')
      const svgPoint = $(`svg g[id="${slideid}"]`)
      const slide = $(`.info__wrapper[data-slide-location="${slideid}"]`)
        .parent()
        .parent()
        .attr('data-slick-index')

      svgPoint.addClass('active')
      contentSlider.slick('slickGoTo', slide)
    })
  }

  mount() {
    this.tassie()
    $(window).resize()
  }
}



// WEBPACK FOOTER //
// ./scripts/components/WhyTasmania.js